module.exports = __webpack_public_path__ + "img/분식.f43bd0fe.png";